import React, { useContext } from "react";
import { SB3RuleContext } from "../Rules/SB3RuleContext";
import LogicRulePreSubConditionComponent from "./LogicRulePreSubConditionComponent";

const LogicRuleTargetConditionComponent = () => {
  const { deleteLogicalCondtion, logicRule } = useContext(SB3RuleContext);

  return (
    <>
      <div>
        <label className="cart-title tw-m-2">Target</label>
        <div className="rule-condition">
          <div className="left-root-rule-parenthesis" />
          <div>
            {
              <LogicRulePreSubConditionComponent rootIndex={0}
                index={0} data={logicRule?.rule?.target?.conditions} deleteMethod={deleteLogicalCondtion} type="target" />

            }
          </div>
          <div className="right-root-rule-parenthesis" />
        </div>
      </div>
    </>
  );
};

export default LogicRuleTargetConditionComponent;
